<template>
    <a href="#"
       @click.prevent="click"
       class="button button--small button--no-state button--floating button--floating-center"
       :class="{'button--floating-hidden': hide}"
    >
        {{ label }}
    </a>
</template>

<script>

export default {
    name: "FloatingButton",
    props: {
        label: {
            type: String,
            required: true,
        },
        tolerance: {
            type: Number,
            required: false,
            default: 0
        }
    },
    data() {
        return {
            hide: true
        }
    },
    methods: {
        checkHideWithDelay() {
            setTimeout(this.checkHide, 300);
        },
        checkHide() {
            if (((this.$parent.$el.getBoundingClientRect().bottom + this.tolerance) - window.innerHeight) <= 0) {
                this.hide = true;
            } else {
                this.hide = false;
            }
        },
        click(e) {document.activeElement.blur();

            this.$emit('click')
        }
    },
    mounted() {
        this.checkHide();
        document.querySelectorAll('[data-collapsible]').forEach($el => {
            $el.addEventListener('toggle-collapsible', this.checkHideWithDelay)
        });
        document.querySelector('[data-search-panel]').addEventListener('scroll', this.checkHide);
    }
}
</script>